import { reducerWithInitialState } from 'typescript-fsa-reducers';
import {
    yourDesignAction,
    yourDesignDeleteAction,
} from '@app/react/action';
import {
    DesignSet,
    KINTEKI,
    ENTEKI,
    MAKIWARA,
    FULL,
    SEMI,
} from '@app/react/const/type';
import { isDesignSet } from '@app/react/common/isDesignSet';
import { removeItem } from './yourDesignReducerOp';

export interface YourDesignState {
    param: {
        kintekiFull: Array<DesignSet>;
        kintekiSemi: Array<DesignSet>;
        entekiFull: Array<DesignSet>;
        entekiSemi: Array<DesignSet>;
        makiwaraFull: Array<DesignSet>;
    };
}

const initState: YourDesignState = {
    param: {
        kintekiFull: [],
        kintekiSemi: [],
        entekiFull: [],
        entekiSemi: [],
        makiwaraFull: [],
    },
};

function addItem(fuga: DesignSet[], item: DesignSet) {
    const x = fuga.findIndex((v) => isDesignSet(v, item));

    if (x === -1) {
        return [...fuga, item];
    }

    const newValue = [...fuga];
    newValue[x] = item;

    return newValue;
}

export const yourDesignReducer = reducerWithInitialState(initState)
    .case(yourDesignAction.started, (state, action) => {
        const { params, arrowType, orderType } = action;

        if (arrowType === KINTEKI && orderType === FULL) {
            return {
                ...state,
                param: {
                    ...state.param,
                    kintekiFull: addItem(state.param.kintekiFull, params),
                },
            };
        } if (arrowType === KINTEKI && orderType === SEMI) {
            return {
                ...state,
                param: {
                    ...state.param,
                    kintekiSemi: addItem(state.param.kintekiSemi, params),
                },
            };
        } if (arrowType === ENTEKI && orderType === FULL) {
            return {
                ...state,
                param: {
                    ...state.param,
                    entekiFull: addItem(state.param.entekiFull, params),
                },
            };
        } if (arrowType === ENTEKI && orderType === SEMI) {
            return {
                ...state,
                param: {
                    ...state.param,
                    entekiSemi: addItem(state.param.entekiSemi, params),
                },
            };
        } if (arrowType === MAKIWARA && orderType === FULL) {
            return {
                ...state,
                param: {
                    ...state.param,
                    makiwaraFull: addItem(state.param.makiwaraFull, params),
                },
            };
        }

        return {
            ...state,
        };
    })
    .case(yourDesignDeleteAction, (state, action) => {
        const {
            arrowType,
            orderType,
            item: { id, baseId },
        } = action;

        return removeItem(state, id, baseId, arrowType, orderType);
    });
